/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'calendar': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9 5a1 1 0 00-1 1v1H6a1 1 0 00-1 1v10a1 1 0 001 1h12a1 1 0 001-1V8a1 1 0 00-1-1h-2V6a1 1 0 10-2 0v1h-4V6a1 1 0 00-1-1zm-2 6h10v6H7v-6z" _fill="#0071B3"/>'
  }
})
